<div class="modal-header">
    <h5 class="modal-title">Reset password</h5>
    <div class="d-flex">
        <button type="button" class="close" aria-label="Close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</div>
<form [formGroup]="resetPasswordFormGroup" autocomplete="off" (ngSubmit)="resetPassword()">
    <div class="modal-body">
        <div class="row row--gutter">
            <div class="col-lg-12 col-md-12 col-sm-12 ">
                <div class="form-group">
                    <label for="exampleInputPassword1">Password<span class="required">*</span></label>
                    <!-- <div class="password-input"> -->
                    <input class="form-control" id="exampleInputPassword1"
                        type="{{ isPasswordVisible ? 'text' : 'password' }}" autocomplete="off" placeholder="Password"
                        formControlName="password">
                    <!-- <i class="fa fa-eye"
                            (click)="togglePasswordVisibility()"
                            aria-hidden="true" *ngIf="!isPasswordVisible"></i>
                        <i class="fa fa-eye-slash"
                            (click)="togglePasswordVisibility()"
                            aria-hidden="true" *ngIf="isPasswordVisible"></i>
                    </div> -->
                    <div *ngIf="resetPasswordFormGroup.get('password').errors?.required && submitted" class="errors">
                        Password is required
                    </div>
                    <div *ngIf="resetPasswordFormGroup.get('password').hasError('minlength') && submitted"
                        class="errors">
                        Password must be at least 8 characters long.
                    </div>
                    <div *ngIf="resetPasswordFormGroup.get('password').hasError('passwordRequirements') && !resetPasswordFormGroup.get('password').errors?.required"
                        class="errors">
                        Password must contain at least one number, one uppercase
                        letter, one lowercase letter, and one symbol.
                    </div>
                </div>
            </div>

            <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="form-group">
                    <label for="exampleInputPassword1">Confirm password<span class="required">*</span></label>
                    <div class="password-input">
                        <input class="form-control" id="exampleInputcPassword2"
                            type="{{ isPasswordVisible ? 'text' : 'password' }}" autocomplete="off"
                            placeholder="Confirm password" formControlName="cnfPassword">
                        <i class="fa fa-eye" (click)="togglePasswordVisibility()" aria-hidden="true"
                            *ngIf="!isPasswordVisible"></i>
                        <i class="fa fa-eye-slash" (click)="togglePasswordVisibility()" aria-hidden="true"
                            *ngIf="isPasswordVisible"></i>
                    </div>
                    <div class="errors" [hidden]="!resetPasswordFormGroup.get('cnfPassword')?.errors?.mustMatch">
                        passwords doesn't match</div>
                    <div *ngIf="resetPasswordFormGroup.get('cnfPassword').errors?.required && submitted" class="errors">
                        Confirm password is required
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="closeModal()">Close</button>
        <button class="btn btn-primary pull-right" type="submit">Save</button>
    </div>
</form>